function initFields(step) {
  const fieldsToInit = document.querySelectorAll('[id^=contactSubField]:not([id$=Text])');
  fieldsToInit.forEach((field) => {
    const fieldId = field.getAttribute('id');
    const fieldNum = fieldId.replace(/contact(Sub)?Field/, '');
    if(/[A-Z][1-2]?/.test(fieldNum) || fieldNum > step) {
      showHideField(fieldId, 'hide');

      if (fieldNum !== 'O') {
        requireField(fieldId, true);
      }
    }
  });
}

function showHideField(fieldId, action) {
  const field = document.getElementById(fieldId);

  if (field) {
    if (action == 'show') {
      field.style.display = 'block';
      field.querySelector('input, select').removeAttribute('disabled');
    } else {
      field.style.display = 'none';
      field.querySelector('input, select').setAttribute('disabled', 'disabled');
    }

    if (fieldId == 'contactSubFieldA' || fieldId == 'contactSubFieldB') {
      const fieldText = document.getElementById(fieldId+'Text');

      if (action == 'show') {
        fieldText.style.display = 'block';
      } else {
        fieldText.style.display = '';
      }
    }
  }
}

function requireField(fieldId, action) {
  const field = document.getElementById(fieldId);

  if (field) {
    if (action) {
      field.classList.add('is-required');
      field.querySelector('input, select').setAttribute('required', 'required');
    } else {
      field.classList.remove('is-required');
      field.querySelector('input, select').removeAttribute('required');
    }
  }
}

const formSelects = document.querySelectorAll('.cc-contact-form select');
formSelects.forEach((formSelect) => {
  const formSelectWrapper = formSelect.closest('.col-span-2[id]');
  if (formSelectWrapper) {
    const field = formSelectWrapper.getAttribute('id').replace(/contact(Sub)?Field/, '');
    const functionField = 'showField' + field;

    if (field === '5' || field === '7') {
      if (typeof window[functionField] === 'function') {
        window[functionField]();
      }
    }
    formSelect.addEventListener('change', () => {
      if (typeof window[functionField] === 'function') {
        window[functionField]();
      }
    });
  }
});

// 5 - Je suis Utilisateur/Distributeur/Centre de réparation
function showField5() {
  const field5Wrapper = document.querySelector('#contactField5');
  const field5 = field5Wrapper.querySelector('#contactField5 select');
  if (field5) {
    field5Wrapper.classList.remove('md:col-span-1');

    if (field5.selectedIndex === 1) {
      showHideField('contactSubField6', 'show');
      field5Wrapper.classList.add('md:col-span-1');
    } else {
      showHideField('contactSubField6', 'hide');
    }
  }
}

// 7 - J'ai besoin d'aide pour
function showField7() {
  const field7 = document.querySelector('#contactField7 select');
  if (field7) {
    initFields(7);

    if (field7.selectedIndex === 1) {
      showHideField('contactSubField8', 'show');
      showField8();
    } else if (field7.selectedIndex === 2) {
      showHideField('contactSubField9', 'show');
      showField9();
    } else if (field7.selectedIndex === 3) {
      showHideField('contactSubField10', 'show');
      showField10();
    }
  }
}

  // 7.1 - 8 - Ma demande concerne un produit Facom que je possède déjà
  function showField8() {
    const field8 = document.querySelector('#contactSubField8 select');
    if (field8) {
      initFields(8);

      if (field8.selectedIndex === 7) {
        showHideField('contactSubFieldH', 'show');
        showFieldH();
      } else if (field8.selectedIndex > 0 && field8.selectedIndex !== 6) {
        showHideField('contactSubFieldA', 'show');
        showHideField('contactSubFieldD', 'show');
        showHideField('contactSubFieldF', 'show');

        if (field8.selectedIndex === 2) {
          showHideField('contactSubFieldG', 'show');
        } else if (field8.selectedIndex === 5) {
          showHideField('contactSubFieldB', 'show');
          showHideField('contactSubFieldC', 'show');
          showHideField('contactSubFieldK', 'show');
        } else if (field8.selectedIndex === 8) {
          requireField('contactSubFieldA', false);
        }
      }
    }
  }

    // 8.7 - H - Type de document
    function showFieldH() {
      const fieldH = document.querySelector('#contactSubFieldH select');
      if (fieldH) {
        showHideField('contactSubFieldA', 'hide');
        requireField('contactSubFieldA', true);
        showHideField('contactSubFieldB', 'hide');

        if (fieldH.selectedIndex > 0) {
          showHideField('contactSubFieldA', 'show');
          if (fieldH.selectedIndex === 1) {
            requireField('contactSubFieldA', false);
          } else if (fieldH.selectedIndex === 5) {
            showHideField('contactSubFieldB', 'show');
          }
        }
      }
    }

  // 7.2 - 9 - Ma demande concerne un produit Facom que je ne possède pas encore
  function showField9() {
    const field9 = document.querySelector('#contactSubField9 select');
    if (field9) {
      initFields(9);

      if (field9.selectedIndex === 3) {
        showHideField('contactSubFieldI', 'show');
        showFieldI();
      } else if (field9.selectedIndex > 0) {
        if (field9.selectedIndex === 1 || field9.selectedIndex === 2) {
          requireField('contactSubFieldA', false);
        }
        showHideField('contactSubFieldA', 'show');
        showHideField('contactSubFieldD', 'show');
        showHideField('contactSubFieldF', 'show');
      }
    }
  }

    // 9.3 - I - Type de document
    function showFieldI() {
      const fieldI = document.querySelector('#contactSubFieldI select');
      if (fieldI) {
        showHideField('contactSubFieldA', 'hide');
        requireField('contactSubFieldA', true);

        if (fieldI.selectedIndex == 2) {
          showHideField('contactSubFieldA', 'show');
        }
      }
    }

  // 7.3 - 10 - Ma demande concerne autre chose
  function showField10() {
    const field10 = document.querySelector('#contactSubField10 select');
    if (field10) {
      initFields(10);

      if (field10.selectedIndex === 1) {
        showHideField('contactSubFieldJ', 'show');
        showFieldJ();
      } else if (field10.selectedIndex === 2) {
        showHideField('contactSubFieldA', 'show');
        requireField('contactSubFieldA', false);
        showHideField('contactSubFieldD', 'show');
        showHideField('contactSubFieldF', 'show');
      }
    }
  }

    // 10.1 - J - Type de document
    function showFieldJ() {
      const fieldJ = document.querySelector('#contactSubFieldJ select');
      if (fieldJ) {
        showHideField('contactSubFieldA', 'hide');
        requireField('contactSubFieldA', true);
        showHideField('contactSubFieldB', 'hide');

        if (fieldJ.selectedIndex == 2) {
          showHideField('contactSubFieldA', 'show');
          showHideField('contactSubFieldB', 'show');
        }
      }
    }
